export default {
  DATA_VALIDATION_TITLE: 'Data validation',
  DATA_VALIDATION_SUBTITLE: 'Please provide data validation information',
  DATA_VALIDATION_CAPTION:
    'Data validation will be used to verify the employee base salary. This section is optional and can be setup later if needed.',
  DATA_VALIDATION_BODY:
    `Configure the data components to be validated for discrepancies in the employee data. The outcome of this validation can be accessed through the Data Validation widget on the dashboard. <strong><i>&ltPlease note this feature is not yet complete to be configured through the user interface&gt</i></strong>.`,
  MOBILITY_CARD_TITLE: 'Data validation file',
};
